import { styled } from 'styled-components'

export const LayOut_Main = styled.section`
  display: flex;
  flex-direction: column;
  padding-top: 65px; /* 헤더 높이만큼 패딩 추가 */
  min-height: 100vh; // 화면의 높이를 최소값으로 설정
  min-width: 1200px;
`

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  padding: 20px 50px;
  align-items: center;
  flex: 1;
  * {
    max-width: 2000px;
  }
`
